import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Icon from '../../refresh/atoms/Icon';
import { setNetworkStatus } from '../../actions/appAction';
import { isNavigatorDefined } from '../../utils/pageInfo.js';
import '../../static/scss/mobile/partials/networkStatus.scss';

function getConnection() {
  return navigator.connection || navigator.mozConnection || navigator.webkitConnection;
}

class NetworkStatuses extends PureComponent {
  constructor(props) {
    super(props);
    this.connection = isNavigatorDefined() && getConnection();
    this.state = {
      type: this.connection ? this.connection.effectiveType : '4g',
      previousOnlineStatus: isNavigatorDefined() ? navigator.onLine : '4g',
      showNetworkStatus: undefined
    };
  }

  updateConnectionStatus = () => {
    let showNetworkStatus;
    let currentOnlineStatus;

    if (navigator.onLine) {
      const { previousOnlineStatus, type } = this.state;
      if (!previousOnlineStatus && type === '4g') {
        showNetworkStatus = true;
      }
      currentOnlineStatus = true;
    } else {
      currentOnlineStatus = false;
      showNetworkStatus = false;
    }
    const updatedOptions = {
      previousOnlineStatus: currentOnlineStatus,
      type: this.connection ? this.connection.effectiveType : '4g'
    };

    if (typeof showNetworkStatus !== 'undefined') {
      updatedOptions.showNetworkStatus = showNetworkStatus;
    }

    this.setState(updatedOptions, () => {
      if (updatedOptions.showNetworkStatus) {
        setTimeout(() => {
          this.setState({
            showNetworkStatus: false
          });
        }, 10000);
      }
    });
  };

  reloadPage = () => {
    window.location.reload();
  };

  closeNetworkStatus = () => {
    this.setState({
      showNetworkStatus: undefined
    });
  };

  updateOnlineStatus = status => {
    return () => {
      this.props.setNetworkStatus(status);
      this.setState(
        {
          showNetworkStatus: status === 1
        },
        () => {
          setTimeout(() => {
            this.setState({
              showNetworkStatus: undefined
            });
          }, 10000);
        }
      );
    };
  };

  componentDidMount() {
    window.addEventListener('online', this.updateOnlineStatus(0));
    window.addEventListener('offline', this.updateOnlineStatus(1));
    // this.connection =  this.connection.addEventListener('change', this.updateConnectionStatus);
  }

  render() {
    const { showNetworkStatus } = this.state;
    // if(!showNetworkStatus){
    //   return null;
    // }
    if (showNetworkStatus === false) {
      return (
        <div className="network-status">
          <div className="network-status__icon-container">
            <Icon
              ariaLabel='close'
              onClick={this.closeNetworkStatus}
              icon="icon-Close"
              styles={{ fontSize: '1.2rem', color: '#202020', fontWeight: 'bold' }}
            />
            <span className="network-status__msg">You are back online</span>
          </div>

          <button className="network-status__reload-btn" onClick={this.reloadPage}>
            Reload
          </button>
        </div>
      );
    }
    if (showNetworkStatus === true) {
      return (
        <div className="network-status">
          <div className="network-status__icon-container">
            <Icon
              ariaLabel='close'
              onClick={this.closeNetworkStatus}
              icon="icon-Close"
              styles={{ fontSize: '1.2rem', color: '#202020', fontWeight: 'bold' }}
            />
          </div>
          <span className="network-status__msg network-status__msg__offline">You are offline</span>
        </div>
      );
    }
    return null;
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setNetworkStatus: status => {
      dispatch(setNetworkStatus(status));
    }
  };
};

export default connect(null, mapDispatchToProps)(NetworkStatuses);
